export enum Language {
    EN,
    DE
}